import React, { Fragment } from "react";
import PropTypes from "prop-types";
import FormatDate from "./FormatDate.jsx";

const FormatDateRange = ({ start, end }) => {
  return (
    <Fragment>
      {start && start === end ? (
        <FormatDate value={end} />
      ) : (
        <Fragment>
          <FormatDate value={start} /> - <FormatDate value={end} />
        </Fragment>
      )}
    </Fragment>
  );
};

FormatDateRange.propTypes = {
  start: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
};

FormatDateRange.displayName = `FormatDateRange`;

export default FormatDateRange;
